<template>
  <v-card tile flat :class="$style.borderVertical" style="height: 100%">
    <v-card-title class="flex flex-column align-start">
      <div>Händelse</div>
      <div class="text-subtitle-2 text--secondary">UUID: {{ event.uuid }}</div>
    </v-card-title>

    <v-card-text class="mt-2">
      <v-row>
        <v-col class="mt-7">
          <EventTitleField disabled />
          <EventTimeStartField disabled />
          <EventLocationField disabled />
          <EventRoutesField disabled />

          <v-card flat outlined class="grey lighten-4" height="216">
            <v-card-text>
              <v-row>
                <EventReasonField disabled />
                <EventOperationLevelField disabled />
              </v-row>
              <EventBasunFields disabled />
            </v-card-text>
          </v-card>
          <v-row>
            <v-col>
              <v-textarea
                no-resize
                outlined
                disabled
                label="Kommentar"
                v-model="model.comment"
                placeholder=" "
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { sync, get } from 'vuex-pathify'
import EventTitleField from '@/modules/event/components/EventForm/EventTitleField'
import EventTimeStartField from '@/modules/event/components/EventForm/EventTimeStartField'
import EventRoutesField from '@/modules/event/components/EventForm/EventRoutesField'
import EventReasonField from '@/modules/event/components/EventForm/EventReasonField'
import EventOperationLevelField from '@/modules/event/components/EventForm/EventOperationLevelField'
import EventBasunFields from '@/modules/event/components/EventForm/EventBasunFields'
import EventLocationField from '@/modules/event/components/EventForm/EventLocationField'

export default {
  name: 'HistoryEventInfo',

  components: {
    EventTitleField,
    EventTimeStartField,
    EventRoutesField,
    EventReasonField,
    EventOperationLevelField,
    EventBasunFields,
    EventLocationField
  },

  created() {
    const updateModel = Object.keys(this.model).reduce((acc, key) => {
      if (['time_start'].includes(key)) {
        if (!this.event[key]) {
          acc[key] = new Date()
        } else {
          acc[key] = new Date(this.event[key])
        }

        return acc
      }

      if (
        ['operation_level_uuid'].includes(key) &&
        this.event.operation_level
      ) {
        acc[key] = this.event.operation_level.uuid
        return acc
      }

      if (['reason_uuid'].includes(key) && this.event.reason) {
        acc[key] = this.event.reason.uuid
        return acc
      }

      if (['routes'].includes(key)) {
        acc[key] = this.event?.routes || []
        return acc
      }

      acc[key] = this.event[key]

      return acc
    }, {})

    this.$store.set('event/model', {
      ...updateModel
    })
  },

  computed: {
    model: sync('event/model'),
    event: get('event/selectedEvent')
  },

  beforeDestroy() {
    this.$store.commit('event/resetModel')
  }
}
</script>

<style lang="scss" module>
.borderVertical {
  border-right: 1px solid rgba(#000, 0.12) !important;
}
</style>
